import { formatCurrency } from 'helpers/formatting';

export default function unitPriceTemplate(value, row) {
  if (typeof row.id === 'string') {
    return {
      props: {
        colSpan: 0
      },
    };
  }
  return formatCurrency(value);
}
